import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { DropZone } from "@circle-react/components/shared/DropZone";
import { ImagePreview } from "./ImagePreview";
import "./styles.scss";

export interface FormDropZoneProps {
  accept: string;
  name: string;
  onRemove?: () => void;
  rules: RegisterOptions;
}

export const FormDropZone = ({
  name,
  rules,
  accept,
  onRemove,
}: FormDropZoneProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { onChange, value },
      }: {
        field: { onChange: (value: File | null) => void; value: File | null };
      }) => {
        const handleFileDrop = (files: FileList | null) => {
          onChange(files?.[0] || null);
        };

        const reset = () => onChange(null);

        if (value) {
          return (
            <ImagePreview value={value} onRemove={onRemove} reset={reset} />
          );
        }
        return <DropZone accept={accept} onFileDrop={handleFileDrop} />;
      }}
    />
  );
};

FormDropZone.displayName = "Form.DropZone";
